<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1 class="headline mb-2">
          {{ $tt('marketInsights.title') }}
          <v-chip x-small outlined color="primary" class="ml-1">BETA</v-chip>
        </h1>
        <p>{{ $tt('marketInsights.description') }}</p>

        <v-alert v-if="!isPaidMember" type="info" outlined>
          {{ $tt('marketInsights.upsell') }}
          <div class="mt-3">
            <v-btn color="primary" to="/billing">{{ $tt('customBillingMenu') }}</v-btn>
          </div>
        </v-alert>

        <v-row v-else>
          <v-col cols="12" sm="6">
            <v-card>
              <v-card-title>🌱 Soybean Monitor</v-card-title>
              <v-card-text>{{ $tt('marketInsights.soybeanDescription') }}</v-card-text>
              <v-card-actions>
                <v-btn color="primary" :loading="opening === 'soybean'" @click="openMonitor('soybean')">
                  {{ $tt('marketInsights.open') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card>
              <v-card-title>🌾 Wheat Monitor</v-card-title>
              <v-card-text>{{ $tt('marketInsights.wheatDescription') }}</v-card-text>
              <v-card-actions>
                <v-btn color="primary" :loading="opening === 'wheat'" @click="openMonitor('wheat')">
                  {{ $tt('marketInsights.open') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <p class="caption mt-4">{{ $tt('marketInsights.memberNote') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserInfo from '@/lib/user-info'
import connectPayClient from '@/lib/connect-client/connect-pay-client'
import * as Constants from '@/lib/constants'

export default {
  name: 'MarketInsights',
  data() {
    return {
      opening: null,
    }
  },
  computed: {
    isPaidMember() {
      return !UserInfo.hasFreeFunctionality()
    },
  },
  methods: {
    monitorUrl(kind) {
      return kind === 'wheat' ? Constants.WHEAT_MONITOR_URL : Constants.SOYBEAN_MONITOR_URL
    },
    openMonitor(kind) {
      this.opening = kind
      connectPayClient
        .getMarketMonitorAccessToken()
        .then(response => {
          const token = response.data && response.data.accessToken
          const url = token ? this.monitorUrl(kind) + '?token=' + encodeURIComponent(token) : this.monitorUrl(kind)
          window.open(url, '_blank', 'noopener')
        })
        .catch(error => {
          console.error(error.response || error)
          // Phase 1 はトークンなしでも閲覧可能のため、取得失敗時もそのまま開く
          window.open(this.monitorUrl(kind), '_blank', 'noopener')
        })
        .finally(() => {
          this.opening = null
        })
    },
  },
}
</script>
